import range from 'lodash.range';

import { format, setMonth, getYear } from 'date-fns';
import { enUS, nl, de, fr } from 'date-fns/locale';

export const CURRENT_YEAR = getYear(new Date());
export const PAST_YEARS = 100;
const LOCALES = {
  en: enUS,
  nl,
  de,
  fr
};
const MONTH_MASK = 'MMMM';

export function generateMonths(locale = 'en') {
  const selectedLocale = LOCALES[locale];

  const monthNumbers = range(0, 12);

  function createDates(monthNumber) {
    return setMonth(new Date(), monthNumber);
  }

  function getMonthNames(fullDate) {
    return format(fullDate, MONTH_MASK, { locale: selectedLocale });
  }

  return monthNumbers.map(createDates).map(getMonthNames);
}

export function generateDays(daysInMonth = 31) {
  return range(1, daysInMonth + 1).map(day => ({
    text: day,
    value: day
  }));
}

export function generateYears(params = {}) {
  const {
    minYear = CURRENT_YEAR - PAST_YEARS,
    maxYear = CURRENT_YEAR
  } = params;

  return range(minYear, maxYear + 1).reverse();
}

export const dateDays = generateDays();

export const dateMonths = locale =>
  generateMonths(locale).map((m, index) => ({
    text: m,
    value: index
  }));

export const dateYears = opts =>
  generateYears(opts).map(y => ({
    text: y,
    value: y
  }));
